// extracted by mini-css-extract-plugin
export var attribution = "_a7-4";
export var authorName = "_a7-5";
export var quote = "_a7-3";
export var testimonial = "_a7-2";
export var trustedBy = "_a7-0";
export var trustedByLabel = "_a7-1";